import PaymentsList from './list-payments.tsx';

export default function StandardPayments() {
  return <PaymentsList type="standard" title="Standard Payments" />;
}
